import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getHostBillingSystem } from '@atlassian/mpac-api-client';
import { buildContext, instanceToModule, returnsPromise } from './connect/Util';
import { supports } from './constants';
import { getHostStatusFromUpm } from './upmApi';
let Extra = (_class = class Extra {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  getHostInfo() {
    return Promise.resolve(_objectSpread(_objectSpread({
      supports,
      product: this.config.product
    }, this.config.subproduct ? {
      subproduct: this.config.subproduct
    } : {}), {}, {
      baseUrl: this.config.baseUrl,
      globalContext: buildContext(this.config)
    }));
  }
  async getHostPricingInfo(fetchHostBillingSystemFromDemandServiceFlag) {
    if (fetchHostBillingSystemFromDemandServiceFlag && this.config.product === 'compass') {
      const hostBillingSystem = await getHostBillingSystem(this.config.cloudId);
      /* This is being done only for compass apps, excluding billingSystem property
      all the other properties are mocked with dummy data as compass installation doesn't need any of those
      as all the compass apps are free for now. */
      return {
        instanceType: 'production',
        evaluation: false,
        currentLicensedUsers: 0,
        renewalType: 'auto',
        maximumLicensedUsers: 0,
        billingCurrency: 'USD',
        subscriptionPeriod: 'monthly',
        hostCmtEnabled: false,
        billingSystem: hostBillingSystem.billingSystem
      };
    }
    const hostStatus = await getHostStatusFromUpm(this.config.baseUrl);
    return {
      instanceType: hostStatus.instanceType,
      billingSystem: hostStatus.billingSystem,
      evaluation: hostStatus.hostLicense.evaluation,
      currentLicensedUsers: hostStatus.upmLicensedHostUsers,
      renewalType: hostStatus.hostLicense.autoRenewal ? 'auto' : 'quote',
      maximumLicensedUsers: hostStatus.hostLicense.maximumNumberOfUsers,
      billingCurrency: hostStatus.billingCurrency,
      subscriptionPeriod: Object.prototype.hasOwnProperty.call(hostStatus.hostLicense, 'subscriptionAnnual') ? hostStatus.hostLicense.subscriptionAnnual ? 'annual' : 'monthly' : 'monthly',
      hostCmtEnabled: Boolean(hostStatus.hostCmtEnabled)
    };
  }
}, (_applyDecoratedDescriptor(_class.prototype, "getHostInfo", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "getHostInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getHostPricingInfo", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "getHostPricingInfo"), _class.prototype)), _class);
export default (config => instanceToModule(new Extra(config)));